module.exports = __webpack_public_path__ + "img/be.58adc89d.png";